<div *ngIf="isLoading">
  <app-loader></app-loader>
</div>
<div class="container mx-auto px-4 md:px-8 py-12 mt-16 max-w-4xl">
  <div class="text-center mb-12 sm:mb-16 relative">
    <h2 class="text-2xl sm:text-3xl font-extrabold text-gray-800">ABOUT US</h2>
    <div
      class="w-16 sm:w-20 h-1 bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] mx-auto mt-2 rounded-full"
    ></div>
  </div>

  <!-- Primary Video Section -->
  <div *ngIf="aboutUsVideo" class="mb-10">
    <div class="relative rounded-2xl overflow-hidden shadow-lg group">
      <div class="relative aspect-video">
        <video
          #videoElement
          class="w-full h-full object-cover"
          [src]="aboutUsVideo"
          playsinline
          (loadedmetadata)="onVideoLoadedMetadata()"
          (ended)="onVideoEnded()"
        ></video>

        <div
          class="absolute inset-0 bg-black/20 flex items-center justify-center transition-opacity cursor-pointer"
          [class.opacity-0]="!isVideoPaused"
          [class.opacity-100]="isVideoPaused"
          (click)="toggleVideoPlay(videoElement)"
        >
          <div
            class="bg-white rounded-full w-24 h-24 flex items-center justify-center shadow-2xl hover:scale-110 transition-transform"
          >
            <i class="fas fa-play text-[#FF5858] text-4xl"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="about-content text-gray-700 leading-relaxed text-justify"
    [innerHTML]="aboutUsContent"
  ></div>
</div>
